import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';
var project = {
  path: '/projectInfo',
  redirect: '/projectInfo',
  component: RootLayout,
  children: [{
    path: '/projectInfo',
    name: 'ProjectInfo',
    component: function component() {
      return import('@/views/project/index.vue');
    },
    meta: {
      title: '项目详情'
    }
  }, {
    path: '/transactionDetails',
    name: 'TransactionDetails',
    component: function component() {
      return import('@/views/project/transactionDetails.vue');
    },
    meta: {
      title: '成交详情'
    }
  }, {
    path: '/projectInfo/integralRule',
    name: 'IntegralRule',
    component: function component() {
      return import('views/project/IntegralRule.vue');
    },
    meta: {
      title: 'U-niverse积分规则'
    }
  }]
};
export default project;